const dev = {
    video_intro: {
        url: 'https://www.youtube.com/watch?v=iTEMvKlue3w',
        id: 'iTEMvKlue3w'
    },

    api: {
        send_email: 'http://1.55.212.41:9000/api/mail/send-mail',
        insert_quest: 'http://1.55.212.41:9100/api/users/registered-users',
    },

    email: 'infoerp@infoplusvn.com',

    facebook: {
        pageId: '112556081085822', // get from facebook page about
        appId: '842127353072981' // create business app by facebook developers and setup messenger
    }
}

export default dev;